export enum ErrorTexts {
    required = 'Please fill all required fields',
    minLength = 'Password should be at least 10 symbols',
    regExp = 'Password should have at least 1 uppercase, 1 lowercase, 1 digit and 1 special char',
    confirmationError = 'Confirmation doesn`t match password',
    dePlateNumber = 'GERMAN_DELIMITER',
}
